import { CheckoutState } from '../../state';
import {
    getAreAsyncExpressCheckoutEligibleCommonRulesMet,
    isApplePayAvailableAsExpressPaymentMethod,
} from '../expressCheckoutConditions';
import { hasApplePayAsyncErrors } from './pureSelectors';

export const areAsyncExpressApplePayEligibleRulesMet = (state: CheckoutState) =>
    getAreAsyncExpressCheckoutEligibleCommonRulesMet(state) &&
    isApplePayAvailableAsExpressPaymentMethod(state) &&
    !hasApplePayAsyncErrors(state);
